module.exports = __webpack_public_path__ + "vue-assets/img/wlc.55931093.svg";